import React from 'react';

import { Container, ConfirmButton } from './styles';

export interface Props {
  children: string;
  isEdit: boolean;
  dirty: boolean;
  loading?: boolean;
  disabled?: boolean;
}

const SubmitButton = ({ children, isEdit, dirty, loading, disabled }: Props) => {
  if (!isEdit || dirty) {
    return (
      <Container fixed={isEdit}>
        <ConfirmButton type="submit" value={children} loading={loading} disabled={loading || disabled} />
      </Container>
    );
  } else return null;
};

export default SubmitButton;
